// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('configuration', {
    parent: 'main',
    url: '/configuration',
    views: {
      'main-content': {
        controller: 'MainConfigurationController as vm',
        templateUrl: 'main/configuration/configuration.tpl.html',
      },
    },
    resolve: {
      configurationOptions() {
        return { selectedBranch: null };
      },
    },
    data: { pageTitle: 'Configuration' },
  });
};

class MainConfigurationController {
  constructor($scope, $state, currentOrganization, AuthService) {
    'ngInject';

    this.$scope = $scope;
    this.$state = $state;
    this.organizationName = currentOrganization.name;
    this.defaultRoute = AuthService.hasAnyClaim(['SystemAdministrator'])
      ? 'configuration.articleTemplates'
      : 'configuration.garp';

    $scope.$on('$stateChangeSuccess', () => {
      if (this.$state.is('configuration')) {
        this.goToDefaultState();
      }
    });
  }

  goToDefaultState() {
    this.$scope.$applyAsync(() => {
      this.$state.go(this.defaultRoute, {}, { location: 'replace' });
    });
  }
}

angular
  .module('main.configuration', [
    'configuration.articleTemplates',
    'configuration.articleTags',
    'configuration.branches',
    'configuration.countries',
    'configuration.matrixGroups',
    'configuration.matrixNodes',
    'configuration.currencies',
    'configuration.customsCodes',
    'configuration.garp',
    'configuration.deliveryMethods',
    'configuration.deliveryTerms',
    'configuration.paymentTerms',
    'configuration.freightCosts',
    'configuration.handlingFees',
    'configuration.materials',
    'configuration.productGroups',
    'configuration.complianceDocumentDefinitions',
    'configuration.techniques',
    'configuration.organization',
    'configuration.vatCodes',
    'configuration.treatments',
    'configuration.dimensionGroups',
    'configuration.vdcTemplates',
    'configuration.vdcTiers',
    'configuration.internalApi',
    'configuration.qualities',
    'configuration.branchRegions',
  ])
  .config(config)
  .controller('MainConfigurationController', MainConfigurationController);
